import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

/**
 * MARITIME GLOBAL OVERRIDE
 * Injects critical CSS to normalize the viewport and enforce the dark-ops theme.
 * Added logic to prevent flash of unstyled content (FOUC).
 */
const injectGlobalStyles = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    /* Viewport Normalization */
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box !important;
      -webkit-tap-highlight-color: transparent;
    }

    /* Maritime Core Theme Enforced */
    html, body {
      width: 100%;
      min-height: 100%;
      margin: 0;
      padding: 0;
      background-color: #0a0a0b; 
      color: #ffffff;
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      overflow-x: hidden;
    }

    #root {
      width: 100%;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }

    /* Brand-specific Asset Selection */
    ::selection {
      background: rgba(109, 155, 195, 0.3);
      color: #ffffff;
    }

    /* UI Logic: Scrollbar appearance for Dark-Ops */
    ::-webkit-scrollbar {
      width: 6px;
    }
    ::-webkit-scrollbar-track {
      background: #0a0a0b;
    }
    ::-webkit-scrollbar-thumb {
      background: #2b2d42;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #6D9BC3;
    }

    /* Smooth Transitions for Suite Components */
    .fade-enter { opacity: 0; }
    .fade-enter-active { opacity: 1; transition: opacity 300ms; }
  `;
  document.head.appendChild(style);
};

// Initialize Styles before rendering
injectGlobalStyles();

const root = ReactDOM.createRoot(document.getElementById("root"));

/**
 * ROOT INITIALIZATION
 * AuthProvider wraps the App to provide security context across all routes.
 * Strictly using the AuthProvider's internal socket to prevent "Invalid Namespace" conflicts.
 */
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);